export enum MacOrigin {
    Patient = 1,
    Provider = 2
}

export const macOriginLabel = (origin?: MacOrigin | null): string => (origin == null ? "" : MacOrigin[origin]);
